'use strict';

/* jshint -W098 */
define('PaymentInformationView',
  ['backbone', 'NVTagCallbacks', 'doublebracket', 'moment', 'FieldsetView', 'FastAction', 'currency', 'assetUrl'],
  function (Backbone, invokeCallbacks, DoubleBracket, moment, FieldsetView, FastAction, currency, assetUrl) {
    /* jshint +W098 */
    var _ = Backbone._;
    var $ = Backbone.$;

    return FieldsetView.extend({
      __name__: 'PaymentInformationView',
      readonly: false,
      events: {
        'change': 'renderFeedback',
        'change *': 'touch',
        'change input[name="PaymentMethod"]': 'changePaymentMethodEventHandler',
        'click .change-account': 'changeAccount',
        'payment.cardType': 'setCardType',
        'focus .eft-input': 'eftInputFocus',
        'blur .eft-input': 'eftInputFocus',
        'click .at-whatsthis': 'openEftWhatsThisModal',
        'keypress .at-whatsthis': 'openEftWhatsThisModal'
      },
      accepted: {
        visa: {index: 0, name: 'Visa'},
        dinersclub: {index: 1, name: 'Diners Club'},
        mastercard: {index: 2, name: 'Master Card'},
        amex: {index: 3, name: 'American Express'},
        discover: {index: 4, name: 'Discover'}
      },
      initialize: function () {
        FieldsetView.prototype.initialize.call(this);
        _.bindAll(this, 'changeReadonly', 'amountChanged', 'recurrenceChanged');
        var byCardIndex = _.bind(function (a, b) {
          return this.accepted[a].index - this.accepted[b].index;
        }, this);

        this.cards = this.options.accepted_cards.slice(0).sort(byCardIndex);

        if (this.options.post_response && this.options.post_response.cc4Digit && !this.options.disableCreditCardAutofill) {
          this.readonly = true;
        }

        this.cardType = 'unknown';
        this.originalSubmitLabel = this.options.parent.context().submit_label;
        this.contributionAmountModel = this.options.formview.contributionAmountModel;
        this.contributionRecurrenceModel = this.options.formview.contributionRecurrenceModel;

        // In the case of ticketed event forms, this fieldset isn't required and should be hidden when the amount is non-zero
        this.hideForNoAmount = this.options.formview.options.form_definition.type === 'EventForm';
        this.hide = this.hideForNoAmount && (this.contributionAmountModel.get('totalAmount') <= 0);

        this.listenTo(this.options.formview, 'paymentMethodChanged', this.changePaymentMethod);
        this.listenTo(this.options.formview, 'paypalAuthorized', this.setPayPalDisplay);
        this.listenTo(this.options.formview, 'applePayAuthorized', this.setApplePayDisplay);
        this.contributionAmountModel.on('change:totalAmount', this.amountChanged);
        this.contributionRecurrenceModel.on('change', this.recurrenceChanged);

        this.applepayAuthorizedAmount = null;
        this.applePayAuthorizedFrequency = null;
        this.paypalAuthorizedRecurring = null;
      },
      recurrenceChanged: function () {
        // When the recurring flag is toggled, 
        if (this.contributionRecurrenceModel.hasChanged('isRecurring')) {
          // If Paypal is authorized for a single payment only, we'll need to 
          // tell the user to reauthorize if they've upgraded to recurring.
          if (this.isPayPalAuthorized()) {
            this.renderFeedback();
          }
        }

        this.updateSubmitText();
      },
      amountChanged: function () {
        var newAmount = this.contributionAmountModel.get('totalAmount');
        var previousAmount = this.contributionAmountModel.previous('totalAmount');

        if (this.hideForNoAmount) {
          // Don't re-render every time the amount changes, just when toggling is necessary
          var paymentRequired = newAmount > 0;
          var shouldResetVisibility = !previousAmount || (paymentRequired !== (previousAmount > 0));
          if (shouldResetVisibility) {
            this.options.definition.required = paymentRequired;
            this.hide = !paymentRequired;

            // Re-render, then manually set correct display properties
            this.render();

            if (this.previousVal) {
              this.setval(this.previousVal);
            }
          }
        } 
        
        if (this.isPayPalAuthorized()) {
          this.$('.at-paypal-amount').text(currency.format(newAmount));
        }

        // If Apple Pay has been authorized, update feedback for amount being the same as the authorized amount
        if (this.isApplePayAuthorized()) {
          this.renderFeedback();
        }

        this.updateSubmitText();
        
      },
      isApplePayAuthorized: function () {
        return  this.options.formview.paymentMethodConfiguration.isApplePayEnabled && $('input[name="paymentResponseDetails"]').val();
      },
      isPayPalAuthorized: function () {
        return  this.options.formview.paymentMethodConfiguration.isPayPalEnabled && $('input[name="paypalNonce"]').val();
      },
      changeAccount: function (e) {
        e.preventDefault();

        if (this.selectedPaymentMethod === 'creditcard') {
        delete this.options.post_response;
        delete this.options.previous_payment;
        this.changeReadonly(false);
        this.subviews.Account.focus();
        }
        
        return this;
      },
      changeReadonly: function (readonlyState, cc_4_digit, cc_type) {
        if (_.isBoolean(readonlyState)) {
          if (cc_type) {
            this.cc_type = cc_type.toLowerCase();
          }

          if (cc_4_digit) {
            this.cc_4_digit = cc_4_digit;
          }

          if (readonlyState === this.readonly && !cc_4_digit) {
            return this;
          }

          if (_.indexOf(this.cards, this.cc_type) === -1) {
            readonlyState = false;
          }

          this.readonly = !this.options.isKioskEnabled && readonlyState && !this.options.disableCreditCardAutofill;
          this.def.required = !this.hide && !this.readonly;

          var user = require('fastActionUser');
          if (!this.readonly) {
            user.unset('cc_4_digit');
            user.unset('cc_type');
            this.cc_type = null;
          } else if (this.cc_4_digit) {
            user.set({
              cc_4_digit: this.cc_4_digit,
              cc_type: this.cc_type
            });
          }

          this.dispose();
          
          return this.render();
        }
        return this;
      },
      getAmount: function () {
        var formviewValues = this.options.formview.val();
        if(!formviewValues){
          return 0;
        }
        return parseFloat(formviewValues.Amount || 0 ) + parseFloat(formviewValues.CoverCostsAmount || 0);
      },
      getAvailablePaymentMethods: function () {
        var isRecurring = this.contributionRecurrenceModel.get('isRecurring');
        // Filter out apple pay if recurring is enabled
        return _.filter(this.options.formview.paymentMethodConfiguration.acceptedPaymentMethods, function(method) {
           return method !== 'applepay' || !isRecurring;
        });
      },
      readonlyCards: function () {
        return _.map(this.cards, function (name) {
          return {'name': name, 'state': (name !== this.cc_type ? 'off' : '')};
        }, this);
      },
      openEftWhatsThisModal: function (e) {
        if (e.type == 'click' || e.keyCode == 13) {
          window.open(assetUrl('bankhelp.html'),
            'efthelp','toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=0,width=400,height=450');
        }
      },
      dispose: function(){
        // dispose subviews
        _.forOwn(this.subviews, function(subview){
          if(subview && _.isFunction(subview.dispose)){
            subview.dispose();
          }
        });
      },
      errors: function () {
        if (this.hide) {
          return [];
        }

        var errors = [];

        switch (this.selectedPaymentMethod) {
          case 'paypal':
          errors = this.errorsForPayPal();
            break;
          case 'eft':
          errors = this.errorsForEft();
            break;
          case 'applepay':
          errors = this.errorsForApplePay();
            break;
          default:
            if (!('required' in this.def) || this.def.required) {
              errors = _(this.subviews).chain().invoke('errors').flatten().compact().value();
            } else if (this.subviews.SecurityCode && this.subviews.SecurityCode.def.required && this.readonly && !this.hide) {
              errors = this.subviews.SecurityCode.errors();
            }
            break;
        }

        return invokeCallbacks('alterError', {
          val: this.val(),
          field_name: this.field_name(),
          errors: errors,
          def: this.def
        }).errors;
      },
      renderFeedbackWithErrors: function (errors) {
        if (!errors || !errors.length) {
          this.clearFeedback();
          return errors;
        }

        if (this.selectedPaymentMethod === 'paypal') {
          this.$('.paypal-label').addClass('error');
          this.$('.paypal-label').find('small.' + 'error').remove();
          this.$('.paypal-label').append(this.error_template({'error_text': errors[0], 'behavior_classes': 'error'}));
        } else if (this.selectedPaymentMethod === 'applepay') {
          this.$('.apple-pay-label').addClass('error');
          this.$('.apple-pay-label').find('small.' + 'error').remove();
          this.$('.apple-pay-label').append(this.error_template({'error_text': errors[0], 'behavior_classes': 'error'}));
        } else if (this.selectedPaymentMethod === 'eft') {
          // This convoluted logic is an attempt to recreate the same validation rules provided by the textboxview for EFT inputs.
          // The either the errors should show one at a time as inputs are focused or
          // all of the errors should show if the submit button is focused or if render is called and nothing has been focused
          this.clearFeedback();
          var forceErrors = this.eftSubmitFocused || _.isEmpty(this.eftInputsFocused);
          for (var i = 0; i < errors.length; i++) {
            if ((forceErrors || this.eftInputsFocused.routingNumber) && errors[i].errorId === this.eftErrorIds.routing) {
              this.$('.routing-number-label').addClass('error');
              this.$('.routing-number-label').find('small.' + 'error').remove();
              this.$('.routing-number-label').append(this.error_template({
                'error_text': errors[i],
                'behavior_classes': 'error'
              }));

              continue;
            }

            if ((forceErrors || this.eftInputsFocused.bankAccountNumber) && errors[i].errorId === this.eftErrorIds.account) {
              this.$('.account-number-label').addClass('error');
              this.$('.account-number-label').find('small.' + 'error').remove();
              this.$('.account-number-label').append(this.error_template({
                'error_text': errors[i],
                'behavior_classes': 'error'
              }));

              continue;
            }

            if ((forceErrors || this.eftInputsFocused.confirmBankAccountNumber) && errors[i].errorId === this.eftErrorIds.accountConfirm) {
              this.$('.confirm-account-number-label').addClass('error');
              this.$('.confirm-account-number-label').find('small.' + 'error').remove();
              this.$('.confirm-account-number-label').append(this.error_template({
                'error_text': errors[i],
                'behavior_classes': 'error'
              }));

              continue;
            }

            if ((forceErrors || this.eftInputsFocused.authorizePayment) && errors[i].errorId === this.eftErrorIds.authorize) {
              this.$('.authorize-payment-label').addClass('error');
            }
          }
        }
        return errors;
      },
      renderFeedback: function () {
        if (this.hide) {
          return [];
        }

        switch (this.selectedPaymentMethod) {
          case 'paypal': 
            return this.renderFeedbackWithErrors(this.errorsForPayPal());
          case 'eft':
            return this.renderFeedbackWithErrors(this.errorsForEft());
          case 'applepay':
            return this.renderFeedbackWithErrors(this.errorsForApplePay());
          default: 
            if (!('required' in this.def) || this.def.required) {
              return FieldsetView.prototype.renderFeedback.call(this);
            } else if (this.subviews.SecurityCode && this.subviews.SecurityCode.def.required && this.readonly && !this.hide) {
              return this.subviews.SecurityCode.renderFeedback();
            } else {
              return [];
            }
        }
      },
      render: function () {
        var config = this.options.formview.paymentMethodConfiguration;

        var context = {
          title: this.title,
          resources: this.resources,
          ccEnabled: config.isCcEnabled,
          paypalEnabled: config.isPayPalEnabled,
          eftEnabled: config.isEftEnabled,
          eftLegalDisclaimer: config.eftLegalDisclaimer,
          applePayEnabled: config.isApplePayEnabled,
          showPaymentMethods: !config.shouldFillFromPaymentResponse
        };

        if (!this.options.isKioskEnabled &&
            (this.readonly ||
              (this.options.post_response && this.options.post_response.confirmationID && this.options.post_response.cc4Digit))) {
          if (!this.readonly || !this.cc_type) {
            this.cc_4_digit = this.options.post_response.cc4Digit;
            this.cc_type = this.options.post_response.ccType.toLowerCase();
          }

          context.cc_4_digit = this.cc_4_digit;
          context.labelhide = this.options.labels === 'inline';

          _.each(this.def.children, function (element, index) {
            if (element.name === 'SecurityCode') {
              context.cvv = {type: 'cvv2', index: index};
            } else if (element.name === 'UpdateMyProfile') {
              context.fa = {type: element.type, index: index};
            }
          });
        } else {
          // Possibly make cards dynamic, if Oberon ever allows
          // that to be changed
          context.cards = this.cards.slice();
          context.children = [];

          var expirationElement = null;
          var expirationIndex = -1;

          _.each(this.def.children, function (element, index) {
            if (element.name === 'Account') {
              context.children.push({type: 'credit_card', index: index, name: element.name});
            } else if (element.name === 'SecurityCode') {
              context.children.push({type: 'cvv2', index: index, name: element.name});
            } else if (/^Expiration/.test(element.name)) {
              //Use the first styled Expiration element to support clients styling either
              if(!expirationElement || (expirationElement && !expirationElement.styles && element.styles)) {
                expirationElement = element;
                expirationIndex = index;
              }
            } else {
              context.children.push({type: element.type, index: index, name: element.name});
            }
          });

          if(expirationElement && expirationIndex >= 0) {
            context.children.push({type: 'cc_expiration', index: expirationIndex, name: expirationElement.name});
          }

          var rows = [['Account', 'ExpirationMonth', 'ExpirationYear', 'ExpirationDate', 'SecurityCode']];
          var child = _.indexBy(context.children, 'name');
          context.rows = _.map(rows, function (row) {
            return _.reduce(row, function (memo, name) {
              if (child[name]) {
                memo.push(child[name]);
                child[name].inRow = true;
              }
              return memo;
            }, []);
          });
          var extra = _.reject(child, {inRow: true});
          if (extra.length) {
            context.rows.push(extra);
          }
        }

        if (this.paypalNonce) {
          context.paypalNonce = this.paypalNonce;
          context.amount = this.contributionAmountModel.get('totalAmount');
          context.paypalAccount = this.paypalAccount;
        }

        context = invokeCallbacks('alterContext', {element: this.type, context: context, def: this.def}).context;
        this.$el.html(this.template(context));

        if (this.selectedPaymentMethod) {
          this.setPaymentInformationDisplay(this.selectedPaymentMethod);
        }

        return this.hideOrShow();
      },
      remove: function () {
        Backbone.View.prototype.remove.call(this);
      },
      errorsForEft: function () {
        var errors = [];
        var integerRegex = /^\d+$/;
        if (this.selectedPaymentMethod === 'eft') {
          if (this.$('#routingNumber').val().length < 9) {
            errors.push(this.toError(this.resources.PrimaryResources.RoutingNumberMustBeNineNumbers, this.eftErrorIds.routing));
          } else if (!integerRegex.test(this.$('#routingNumber').val())) {
            errors.push(this.toError(this.resources.PrimaryResources.RoutingNumberMustBeAllNumbers, this.eftErrorIds.routing));
          }

          if (this.$('#bankAccountNumber').val().length === 0) {
            errors.push(this.toError(this.resources.PrimaryResources.AccountNumberRequired, this.eftErrorIds.account));
          } else if (!integerRegex.test(this.$('#bankAccountNumber').val())) {
            errors.push(this.toError(this.resources.PrimaryResources.AccountNumberMustBeAllNumbers, this.eftErrorIds.account));
          }

          if (this.$('#confirmBankAccountNumber').val().length === 0) {
            errors.push(this.toError(this.resources.PrimaryResources.ConfirmAccountNumberRequired, this.eftErrorIds.accountConfirm));
          } else if (this.$('#confirmBankAccountNumber').val() !== this.$('#bankAccountNumber').val()) {
            errors.push(this.toError(this.resources.PrimaryResources.AccountNumbersDoNotMatch, this.eftErrorIds.accountConfirm));
          }

          if (!$('#authorizePayment').is(':checked')) {
            errors.push(this.toError('Must authorize payment' /* Error text not used */, this.eftErrorIds.authorize));
          }
        }

        this.trigger(errors.length ? 'invalid' : 'valid');
        return errors;
      },
      errorsForPayPal: function () {
        var errors = [];
        if (this.selectedPaymentMethod === 'paypal') {
          if (!this.$('input[name="paypalNonce"]').val()) {
            errors.push(this.toError(this.resources.PrimaryResources.PayPalRequired));
          }
          if (this.paypalExpirationTime && Date.now() > this.paypalExpirationTime) {
            errors.push(this.toError(this.resources.PrimaryResources.PayPalReauthorize));
          } else if (!this.paypalAuthorizedRecurring && this.contributionRecurrenceModel.get('isRecurring')) {
            errors.push(this.toError(this.resources.PrimaryResources.PayPalReauthorizeRecurring));
          }
        }

        this.trigger(errors.length ? 'invalid' : 'valid');
        return errors;
      },
      errorsForApplePay: function () {
        // TODO: Add more robust error handling in VAN-68666
        var errors = [];

        if (this.selectedPaymentMethod === 'applepay') {
          if (!this.$('input[name="paymentResponseDetails"]').val()) {
            errors.push(this.toError(this.resources.PrimaryResources.ApplePayNotComplete));
          }

          // We ask the user to reauthorize with apple pay if they change the amount or frequency
          // of their contribution, or we think the sesion has expired.
          // Because the upsell workflow doesn't update the actual amount client-side, we check the proposed amount if it exists.
          var expectedAmount = this.contributionAmountModel.get('proposedTotalAmount') || this.contributionAmountModel.get('totalAmount');
          if (this.applePayAuthorizedFrequency !== this.contributionRecurrenceModel.get('frequency')
            || this.applepayAuthorizedAmount !== expectedAmount
            || Date.now() > this.applePayExpirationTime) {
            errors.push(this.toError(this.resources.PrimaryResources.ApplePayReauthorize));
          }
        }

        this.trigger(errors.length ? 'invalid' : 'valid');
        return errors;
      },
      updateSubmitText: function () {
        // Update the submit button merge fields based on the current amount and recurrence state
        var amount = this.contributionAmountModel.get('totalAmount');
        var frequencyDisplay = this.contributionRecurrenceModel.getFrequencyDisplayName();
        var submitText = DoubleBracket.simpleFill(this.originalSubmitLabel, {
          'Amount' : currency.format(amount || 0),
          'Frequency' : frequencyDisplay
        }).trim();
        submitText = submitText || _.find(this.parent.model.get('form_elements'), {type: 'submit'}).value;
        this.parent.$('input[type="submit"]').val(submitText);
        this.parent.$('button[type="submit"], .submitStep').text(submitText);
      },
      setPayPalDisplay: function (options) {
        options = options || {};
        
        if (options.nonce) {
          this.$('.at-paypal-amount').text(currency.format(options.amount));
          this.$('.at-paypal-account-info').text(options.email);

          this.paypalAuthorizedRecurring = this.contributionRecurrenceModel.get('isRecurring');
          this.paypalExpirationTime = options.expires;
        } else {
          this.paypalAuthorizedRecurring = null;
          this.paypalExpirationTime = null;
        }

        this.paypalNonce = options.nonce;
        this.paypalAccount = options.email;

        this.$('input[name="paypalNonce"]').val(options.nonce);
        this.$('.at-paypal-accepted-here > .at-payment-integration-container').toggle(!!options.nonce);
        this.clearFeedback();
      },
      setApplePayDisplay: function (options) {
        options = options || {};
        if (options.paymentResponseDetails) {
          this.$('.apple_pay_payment_details').val(JSON.stringify(options.paymentResponseDetails));

          // Show apple payment details section
          this.$('.apple_pay_amount').text(currency.format(options.amount));
          this.$('.apple_pay_card_info').text(options.cardInfo);

          this.applepayAuthorizedAmount = options.amount;
          this.applePayAuthorizedFrequency = this.contributionRecurrenceModel.get('frequency');
          this.applePayExpirationTime = options.expires;
        } else {
          this.$('.apple_pay_payment_details').val('');

          this.applepayAuthorizedAmount = null;
          this.applePayAuthorizedFrequency = null;
          this.applePayExpirationTime = null;
        }

        this.$('.at-apple-pay-accepted-here > .at-payment-integration-container').toggle(!!options.paymentResponseDetails);
        this.clearFeedback();
      },
      changePaymentMethod: function (data) {
        var newMethod = data.newMethod;

        if (newMethod !== this.selectedPaymentMethod) {
          this.setPaymentInformationDisplay(newMethod);
          this.selectedPaymentMethod = newMethod;

          this.parent.subviews.error_console.clear();
          this.clearFeedback();
          invokeCallbacks('postPaymentMethodChanged', {'new_payment_method' : newMethod} );
        }

        // To ensure instant processing occurs after the payment method is changed on this view, 
        // we use a different event for after this view has changed its payment method
        if (data.isUserSelection) {
          this.options.formview.trigger('postPaymentMethodChanged', newMethod);
        }

        return this;
      },
      setPaymentInformationDisplay: function (method) {
        this.$('.at-paypal-accepted-here')
          .toggle(method === 'paypal');

        this.$('.at-eft-accepted-here')
          .toggle(method === 'eft');

        this.$('.at-apple-pay-accepted-here')
          .toggle(method === 'applepay');

        var creditCardVisible = (method === 'creditcard');
        this.def.required = creditCardVisible;
        this.$('.cards').toggle(creditCardVisible);
        this.$('.at-cc-number').toggle(creditCardVisible);
          _.each(this.subviews, function (subview) {
          if (subview.name !== 'PaymentMethod') {
            subview.$el.toggle(creditCardVisible);
          }
          });
      },
      clearFeedback: function () {
        FieldsetView.prototype.clearFeedback.call(this);

        this.$('.paypal-label').find('small.' + 'error').remove();
        this.$('.paypal-label').removeClass('error');
        this.$('.apple-pay-label').find('small.' + 'error').remove();
        this.$('.apple-pay-label').removeClass('error');
        this.$('.routing-number-label').find('small.' + 'error').remove();
        this.$('.routing-number-label').removeClass('error');
        this.$('.account-number-label').find('small.' + 'error').remove();
        this.$('.account-number-label').removeClass('error');
        this.$('.confirm-account-number-label').find('small.' + 'error').remove();
        this.$('.confirm-account-number-label').removeClass('error');
        this.$('.authorize-payment-label').removeClass('error');

        return this;
      },
      val: function () {
        var val = {},
          subview_val;

        if (this.options.post_response && this.options.post_response.confirmationID) {
          // Ensure this ConfirmationID is not expired
          if (moment().unix() > moment(this.options.post_response.contributionDateTimeStamp)
              .add(15, 'minutes').unix() || !this.options.previous_payment) {
            this.options.post_response = null;
            this.options.previous_payment = null;
            return this.render().val();
          } else {
            val = _.merge({ConfirmationID: this.options.post_response.confirmationID}, this.options.previous_payment);
            if (this.subviews.SecurityCode) {
              var cvv = this.subviews.SecurityCode.val();
              if (cvv) {
                val.SecurityCode = cvv;
              }
            }

            return val;
          }
        }

        _.each(this.subviews, function (subview) {
          subview_val = subview.val();

          if (_.isObject(subview_val)) {
            // If it's a dictionary, add it to this dictionary
            _.extend(val, subview_val);
          } else {
            // If just a value, add it to the dictionary, but don't add false-y values
            if (subview_val) {
              val[subview.name] = subview_val;
            }
          }
        });

        if (this.selectedPaymentMethod === 'paypal') {
          val.PayPalNonce = this.$('input[name="paypalNonce"]').val();
        } else if (this.selectedPaymentMethod === 'eft') {
          val.RoutingNumber = this.$('#routingNumber').val();
          val.BankAccountNumber = this.$('#bankAccountNumber').val();
          val.BankAccountType = this.$('#bankAccountType').val();
        } else if (this.selectedPaymentMethod === 'applepay') {
          val.PaymentResponseDetails = this.$('input[name="paymentResponseDetails"]').val();
        }

        if (val.Account ||
          val.ExprirationMonth ||
          val.ExprirationYear ||
          val.SecurityCode) {
          this.previousVal = val;
        }

        // send what credit card info we have if card is saved
        if (!val.Account) {
          if (this.cc_4_digit) {
            val.CreditCardLastFour = this.cc_4_digit;
          }
          if (this.cc_4_digit) {
            val.CreditCardLastFourType = this.cc_type;
          }
        }

        return val;
      },
      _onSubviewsRendered: function () {
        this.$('.updateMyProfileSection').show();
        this.cvc = this.$('input[name="SecurityCode"]');
        this.exp = this.$('input[name="ExpirationDate"]');
        if (this.cc_type) {
          this.cardType = 'unknown';
          this.setCardType(null, this.cc_type);
        }
        FastAction.adjustCheckbox(this);

        // ensure the submit button text is processed in case the amount doesn't get immediately changed
        var self = this;
        _.defer(function(){
          self.updateSubmitText();
        });
      },
      setCardType: function (e, cardType) {
        if (e && e.currentTarget.readOnly) {
          return this;
        }
        var previous = this.cardType;
        this.cardType = cardType;
        var card = this.$('.cc-type, .cvc-type');
        if (this.cvc.length) {
          var cvcLength = this.cvc.prop('placeholder').length;
          if (previous === 'amex' && cardType !== 'amex') {
            this.cvc.prop('placeholder', '•••')
              .prop('minLength', 3)
              .prop('maxLength', 3);
          } else if (previous !== 'amex' && cardType === 'amex') {
            this.cvc.prop('placeholder', '••••')
              .prop('maxlength', 4)
              .prop('minLength', 4);
          }
        }
        card.removeClass(previous + ' unknown').addClass(cardType);
        return this;
      },
      eftInputFocus: function (e) {
        this.eftInputsFocused[e.currentTarget.id] = e.currentTarget.id;
        if (e.relatedTarget &&
            e.relatedTarget.classList.value.indexOf('btn-at-primary') >= 0 &&
            e.relatedTarget.classList.value.indexOf('nextStep') < 0) {
          // if the submit button has been clicked (ignoring the "Next" button for multi-step forms)
          this.eftSubmitFocused = true;
        }
      },
      eftInputsFocused: {},
      eftSubmitFocused: false,
      eftErrorIds: {
        account: 'eft_account_number',
        routing: 'eft_routing_number',
        accountConfirm: 'eft_account_number_confirm',
        authorize: 'eft_authorize'
      },
      type: 'payment_information'
    });
  });

